<template>
  <app-menu
    v-model="menu"
    bottom
    left
    offset-y
    no-gutters
    content-class="pa-2"
    :close-on-content-click="false"
  >

    <template #activator="{ on }">
      <app-button
        icon
        main-icon="$vuetify.icons.zoom"
        tooltip-direction="top"
        :disabled="disabled"
        v-on="on"
      >
        Zoom
      </app-button>
    </template>

    <div class="d-flex flex-row align-center">
      <app-button
        icon
        main-icon="$vuetify.icons.zoomMinus"
        no-tooltip
        :disabled="!isDecreaseAvailable"
        @click="decreaseOffset"
      ></app-button>

      <app-button
        icon
        main-icon="$vuetify.icons.zoomPlus"
        no-tooltip
        :disabled="!isIncreaseAvailable"
        @click="increaseOffset"
      ></app-button>

      <div class="px-2">
        <v-label>
          Display size
        </v-label>
      </div>
    </div>

      <slot></slot>

  </app-menu>
</template>

<script>
  import browserActions from '@/utils/browserActions';
  import AppMenu from '@/components/AppMenu';

  export default {
    name: 'MaterialViewSettingMenu',

    components: {
      AppMenu,
    },

    props: {
      showUnpublished: {
        type: Boolean,
        default: false,
      },
      showUnpublishedHidden: {
        type: Boolean,
        default: false,
      },
      itemHeightOffset: {
        type: Number,
        default: 0,
      },
      step: {
        type: Number,
        default: 50,
      },
      minOffset: {
        type: Number,
        default: -100,
      },
      maxOffset: {
        type: Number,
        default: 200,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      minStep: {
        type: Number,
        default: -3
      },
      maxStep: {
        type: Number,
        default: 4
      }
    },

    data() {
      return {
        menu: false,
        showUnpublishedVal: false,
        stepValue: 0
      };
    },

    computed: {
      itemHeightOffsetVal() {
        return this.stepValue * this.step;
      },

      isIncreaseAvailable() {
        return this.stepValue < this.maxStep;
      },

      isDecreaseAvailable() {
        return this.stepValue > this.minStep;
      },
    },

    watch: {
      showUnpublished: {
        immediate: true,
        handler(v) {
          this.showUnpublishedVal = v;
        },
      },

      stepValue: {
        handler(v) {
          browserActions.setStoredItemOffset(v);
        }
      },

      itemHeightOffsetVal: {
        immediate: true,
        handler(v) {
          this.$emit('update:item-height-offset', v);
        }
      }
    },

    created() {
      this.stepValue = this.getValidStepValue(browserActions.getStoredItemOffset())
      browserActions.setStoredItemOffset(this.stepValue);
    },

    methods: {

      getValidStepValue(v) {
        const { minStep, maxStep } = this;
        v = Math.max(minStep, v);
        v = Math.min(maxStep, v);
        return v;
      },

      increaseOffset() {
        this.$emit('click:increase');
        this.stepValue = Math.min(this.maxStep, this.stepValue + 1);
      },

      decreaseOffset() {
        this.$emit('click:decrease');
        this.stepValue = Math.max(this.minStep, this.stepValue - 1);
      },
    },
  }
</script>